<ion-header>
  <ion-toolbar>
    <ion-title>{{"feedback-component.title" | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <logo></logo>
  <p>{{ 'feedback-component.your-feedback' | translate }}</p>
  <form *ngIf="formGroup" [formGroup]="formGroup">
    <ion-item>
      <ion-textarea autoGrow="true" minlength="3" [rows]="5" aria-label="Feedback"
                    placeholder="{{ 'feedback-component.placeholder' | translate }}" type="text"
                    [formControl]="comment"></ion-textarea>
    </ion-item>
    <ion-item>
      <ion-button slot="end" (click)="send()" [disabled]="!isValid()" color="primary"
                  size="medium">{{ 'feedback-component.send-it' | translate }}</ion-button>
    </ion-item>
  </form>
</ion-content>
